import { useEffect, useState } from 'react'
import useTimeout from '../utils/useTimeout'

export function useTemporaryVisible(timeout = 3000) {
  const [visible, setVisible] = useState()

  const [setAction, clear] = useTimeout(timeout)

  useEffect(() => {
    if (visible) {
      clear()
      setAction(() => {
        setVisible(false)
      })
    }
  }, [visible])

  return [visible, setVisible]
}
